import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBExportFormat, DBRecurringExport, DBRecurringExportProfileInput, DBRecurringExportSourceInput, DBExportType } from '@/types/export';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  recurringExportId: number;
  data: {
    name?: string;
    exportType?: DBExportType;
    format?: DBExportFormat;
    source?: DBRecurringExportSourceInput;
    exportProfileId?: number;
    exportProfile?: DBRecurringExportProfileInput;
    query?: string;
  };
};

type Response = DBRecurringExport;

export const updateRecurringExport = async (
  scope: RequestScope,
  { recurringExportId, data }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const response = await scopedApi(scope).patch<EndpointResponse<Response>>(
      `/recurring_export/${recurringExportId}`,
      {
        ...(data.name !== undefined && { name: data.name }),
        ...(data.exportType !== undefined && { export_type: data.exportType }),
        ...(data.format !== undefined && { format: data.format }),
        ...(data.source !== undefined && {
          source: {
            type: data.source.type,
            host: data.source.host,
            port: data.source.port,
            username: data.source.username,
            ...(data.source.password !== undefined && { password: data.source.password }),
            frequency: data.source.frequency,
            file_template: data.source.fileTemplate,
            ...(data.source.dateTimeTemplateVar !== undefined && { date_time_template_var: data.source.dateTimeTemplateVar }),
          },
        }),
        ...(data.exportProfileId !== undefined && { export_profile_id: data.exportProfileId }),
        ...(data.exportProfile !== undefined && { export_profile: data.exportProfile }),
        ...(data.query !== undefined && { query: data.query }),
      },
      options
    );
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
